import { makeStyles } from '@material-ui/core/styles';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { color } from '../../app/theme';
import { ScheduleType } from '../../app/types';

const useStyles = makeStyles(
  {
    root: {
      marginBottom: 16,
    },
    line: {
      flexGrow: 1,
      borderBottom: `1px solid ${color.$9}`,
    },
    text: {
      margin: '0 16px',
      maxWidth: '80%',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      fontSize: '13px',
      fontWeight: 'normal',
      fontStretch: 'normal',
      fontStyle: 'normal',
      letterSpacing: 'normal',
      color: color.$11,
    },
    order: { display: 'flex', alignItems: 'center', marginBottom: 24 },
    value: {
      width: '100%',
      textAlign: 'center',
      color: color.$13,
      fontSize: '15px',
      lineHeight: '21px',
      wordBreak: 'break-all',
    },
  },
  {
    name: 'PreviewScheduleNode',
  },
);

const PreviewScheduleNode = ({ node }) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { data } = node || {};
  const { type, time, week, month, hasLastDay } = data || {};

  const dayText = useMemo(() => {
    if (type === ScheduleType.WEEK) {
      return [...week].map(w => t(`week${w}`));
    }

    if (type === ScheduleType.MONTH) {
      if (hasLastDay) {
        return t('hasLastDayDisplay');
      }
      return [...month].join(',');
    }

    return null;
  }, [type, week, month, hasLastDay]);

  return (
    <div className={classes.root}>
      <div className={classes.order}>
        <span className={classes.line} />
        <span className={classes.text}>{t('schedule')}</span>
        <span className={classes.line} />
      </div>
      <div className={classes.value}>
        {!hasLastDay && <div>{t(`scheduleType.${type}`)}</div>}
        <div>{dayText}</div>
        <div>{time}</div>
      </div>
    </div>
  );
};

export default PreviewScheduleNode;
